import { storage } from "@unifiedpatents/sso";

export function load(name) {
  return JSON.parse(storage.getItem(name));
}

export function save(name, value) {
  storage.setItem(name, JSON.stringify(value));
}

export function clear(name) {
  storage.removeItem(name);
}

export function loadSelectedTableColumns(name) {
  return (JSON.parse(storage.getItem("selectedTableColumns")) || {})[name];
}

export function saveSelectedTableColumns(name, value) {
  storage.setItem("selectedTableColumns", JSON.stringify({ ...(JSON.parse(storage.getItem("selectedTableColumns")) || {}), [name]: value }));
}
